if (!customElements.get('wlsn-atom-x-heroblock')) {
    class WLSNAtomXHeroblock extends HTMLElement {
        constructor() {
            super();
            this.classes = {
                swiper: 'js-wlsn-atom-x-heroblock-slides',
                thumbs: 'js-wlsn-atom-x-heroblock-thumbs',
                infoWrapper: 'js-wlsn-atom-x-heroblock-info-wrapper',
                reviewsSlider: 'js-wlsn-atom-x-heroblock-reviews-slider',
                list: 'swiper-wrapper',
                item: 'swiper-slide',
                fireworks: 'js-wlsn-atom-x-heroblock-fireworks',
                backgroundImgs: 'js-wlsn-atom-x-heroblock-bkg',
                scrollContent: 'js-wlsn-atom-x-heroblock-scroll-content',
                stickyButtonContent: 'js-wlsn-atom-x-heroblock-button-content',
                navigation: {
                    prev: 'js-wlsn-atom-x-heroblock-prev',
                    next: 'js-wlsn-atom-x-heroblock-next',
                    pagination: 'js-wlsn-atom-x-heroblock-pagination'
                },
            };

            this.elements = {
                slider: this.querySelector(`.${this.classes.swiper}`),
                thumbs: this.querySelector(`.${this.classes.thumbs}`),
                infoWrapper: this.querySelector(`.${this.classes.infoWrapper}`),
                reviewsSlider: this.querySelector(`.${this.classes.reviewsSlider}`),
                list: this.querySelector(`.${this.classes.list}`),
                items: this.querySelectorAll(`.${this.classes.item}`),
                backgroundImgs: this.querySelectorAll(`.${this.classes.backgroundImgs}`),
                scrollContent: this.querySelector(`.${this.classes.scrollContent}`),
                fireworks: this.querySelector(`.${this.classes.fireworks}`),
                stickyButtonContent: this.querySelector(`.${this.classes.stickyButtonContent}`),
                navigation: {
                    prev: this.querySelector(`.${this.classes.navigation.prev}`),
                    next: this.querySelector(`.${this.classes.navigation.next}`),
                    pagination: this.querySelector(`.${this.classes.navigation.pagination}`)
                }
            };

            this.resizeHandler = this.handleResize.bind(this);
            this.scrollHandler = this.handleScroll.bind(this);
        }

        connectedCallback() {
            if (this.checkIfEmpty()) return;

            this.init();
            window.addEventListener('resize', this.resizeHandler);

            if (this.elements.scrollContent) {
                this.addEventListener('wheel', this.scrollHandler, { passive: false });
            }

            this.moveReviewsSlider();
            if (window.Fireworks) {
                this.initFireworks();
            } else {
                document.addEventListener('fireworks:ready', () => this.initFireworks(), { once: true });
            }
            this.initStickyVisibility();
        }

        disconnectedCallback() {
            if (this.swiper) {
                this.swiper.destroy();
            }

            window.removeEventListener('resize', this.resizeHandler);

            if (this.elements.scrollContent) {
                this.removeEventListener('wheel', this.scrollHandler);
            }

            if (this.resizeTimeout) {
                clearTimeout(this.resizeTimeout);
            }
            if (this.hideObserver) {
                this.hideObserver.disconnect();
            }
        }

        checkIfEmpty() {
            const listInner = this.elements.list;
            if (!listInner || !listInner.children.length) {
                this.style.display = 'none';
                return true;
            }
            return false;
        }

        init() {
            if (!this.shouldInitialize()) return;
            this.initializeSwiper();
        }

        shouldInitialize() {
            if (!this.elements.slider || !this.elements.items.length) return false;
            return this.elements.items.length > 1;
        }

        handleResize() {
            if (this.resizeTimeout) clearTimeout(this.resizeTimeout);

            this.resizeTimeout = setTimeout(() => {
                const shouldInit = this.shouldInitialize();

                if (shouldInit && !this.swiper) {
                    this.initializeSwiper();
                } else if (!shouldInit && this.swiper) {
                    this.swiper.destroy(true, true);
                    this.swiper = null;
                }
            }, 300);
        }

        initializeSwiper() {
            const thumbsCount = parseInt(
                this.dataset.heroblockNumberOfShowerThumbs,
                10
            ) || 0;
        
            const totalThumbs =
                this.elements.thumbs?.querySelectorAll('.swiper-slide').length || 0;
        
            const desktopSlidesPerView =
                thumbsCount > 0
                    ? Math.min(thumbsCount, totalThumbs)
                    : 'auto';
        
            this.thumbs = new Swiper(this.elements.thumbs, {
                spaceBetween: 8,
                slidesPerView: 'auto',
                watchSlidesProgress: true,
                breakpoints: {
                    1024: {
                        slidesPerView: desktopSlidesPerView,
                    },
                },
            });
        
            this.swiper = new Swiper(this.elements.slider, {
                slidesPerView: 1,
                spaceBetween: 10,
                watchSlidesProgress: true,
                pagination: {
                    el: this.elements.navigation.pagination,
                    clickable: true,
                },
                navigation: {
                    prevEl: this.elements.navigation.prev,
                    nextEl: this.elements.navigation.next,
                },
                thumbs: {
                    swiper: this.thumbs,
                },
            });
        
            this.swiper.on('slideChange', () => {
                this.updateBackgroundVisibility(this.swiper.activeIndex);
            });
        
            this.updateBackgroundVisibility(this.swiper.activeIndex);
        }
        
        updateBackgroundVisibility(activeIndex) {
            const images = this.elements.backgroundImgs;
            if (!images.length) return;

            images.forEach(img => img.style.display = 'none');

            const active = document.querySelector(
                `.js-wlsn-atom-x-heroblock-bkg[data-slide="${activeIndex}"]`
            );

            if (active) active.style.display = 'block';
        }

        handleScroll(event) {
            const scrollBox = this.elements.scrollContent;
            if (!scrollBox) return;

            const delta = event.deltaY;

            const prevScrollTop = scrollBox.scrollTop;

            scrollBox.scrollTop += delta;

            const atTop = scrollBox.scrollTop === 0;
            const atBottom =
                scrollBox.scrollTop + scrollBox.clientHeight >= scrollBox.scrollHeight;

            const scrolledInside = scrollBox.scrollTop !== prevScrollTop;

            if (scrolledInside && !atTop && !atBottom) {
                event.preventDefault();
            }

        }

        moveReviewsSlider() {
            if (window.innerWidth <= 1023) {
                const reviewsSlider = this.elements.reviewsSlider;
                const infoWrapper = this.elements.infoWrapper;
                if (reviewsSlider && infoWrapper) {
                    infoWrapper.insertAdjacentElement('afterend', reviewsSlider);
                }
            }
        }

        initFireworks() {
            if(!this.elements.fireworks) return;
            const goldOptions = {
                hue: { min: 45, max: 60 },
                brightness: { min: 60, max: 80 },
                decay: { min: 0.015, max: 0.03 }, 
                particleCount: 70,
                trace: 3,
                traceSpeed: 2,
            };

            this.elements.fireworks = new Fireworks.default(this.elements.fireworks, goldOptions);
            this.elements.fireworks.start();
        }

        initStickyVisibility() {
            console.log('initStickyVisibility');
            if (window.innerWidth > 767) return;
        
            const hideOnClasses = this.dataset.hideOnClasses;
            if (!hideOnClasses || !this.elements.stickyButtonContent) return;
        
            const selectors = hideOnClasses
                .split(',')
                .map(item => item.trim())
                .filter(Boolean)
                .map(item => item.startsWith('.') ? item : `.${item}`);
        
            const targets = selectors.flatMap(selector =>
                [...document.querySelectorAll(selector)]
            );
        
            if (!targets.length) return;
        
            this.hideObserver = new IntersectionObserver((entries) => {
                const shouldHide = entries.some(entry => entry.isIntersecting);
        
                this.elements.stickyButtonContent.classList.toggle('is-hidden', shouldHide);
            }, {
                threshold: 0.1
            });
        
            targets.forEach(target => this.hideObserver.observe(target));
        }
    }

    customElements.define('wlsn-atom-x-heroblock', WLSNAtomXHeroblock);
}